import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

interface LeadCtaClickEventProps {
  sourcePage: SourcePages;
  vin: string;
  listingIndex: number;
}

export function LeadCtaClickEvent({
  sourcePage,
  vin,
  listingIndex,
}: LeadCtaClickEventProps): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage,
    feature: Features.listingCard,
    engagement_type: 'lead_cta_click',
    event_context: {
      vin,
      search_result_index: listingIndex,
    },
  };
}
